import { EvaChartStates } from "types/factory";

import { DataEnum } from "models";

import { computeYAxisLocks } from "./mpcLocks";
import { checkSeriesDataXDateGreaterThanMin } from "./utils/checkSeriesDataXDateGreaterThanMin";
import { checkSeriesDataXDateLessThanMax } from "./utils/checkSeriesDataXDateLessThanMax";

export function rateDateLocks(states: Partial<EvaChartStates>) {
  const { locks, product, series } = states;

  let lockedXMinType = undefined;
  let lockedXMaxType = undefined;

  const isUserXMinLock = locks?.xMin?.type !== DataEnum.DefaultDate && locks?.xMin?.value;
  const isUserXMaxLock = locks?.xMax?.type !== DataEnum.DefaultDate && locks?.xMax?.value;

  const lockedXMin =
    locks?.xMin?.type === DataEnum.Reset
      ? undefined
      : isUserXMaxLock || isUserXMinLock //save the lock value if the user inputs a lock for either min or max
      ? locks?.xMin?.value
      : checkSeriesDataXDateGreaterThanMin("2000", series);

  const lockedXMax =
    locks?.xMax?.type === DataEnum.Reset
      ? undefined
      : isUserXMaxLock || isUserXMinLock //save the lock value if the user inputs a lock for either min or max
      ? locks?.xMax?.value
      : checkSeriesDataXDateLessThanMax("2050", series);

  const { lockedYMin, lockedYMax, lockedYMinType, lockedYMaxType } = computeYAxisLocks(
    locks?.yMin,
    locks?.yMax,
    product,
    series
  );

  // If initial lock was undefined, chart has just been switched to and the lock has been set
  // meaning the data has gone beyond the bounds of the lock
  // We will use DefaultDate to track this state until the lock is reset
  if ((!locks?.xMin?.value && lockedXMin) || locks?.xMin?.type === DataEnum.DefaultDate) {
    lockedXMinType = DataEnum.DefaultDate;
  }

  if ((!locks?.xMax?.value && lockedXMax) || locks?.xMax?.type === DataEnum.DefaultDate) {
    lockedXMaxType = DataEnum.DefaultDate;
  }

  return {
    lockedXMin,
    lockedXMax,
    lockedYMin,
    lockedYMax,
    lockedXMinType,
    lockedXMaxType,
    lockedYMinType,
    lockedYMaxType
  };
}
